export const LIST_CHECK_COLUMN = [
  {
    nameColumn: "component",
  },
  {
    nameColumn: "company",
  },
  {
    nameColumn: "account",
  },
  {
    nameColumn: "exemptionSubCategory",
  },
  {
    nameColumn: "itemCode",
  },
  {
    nameColumn: "salesPerson",
  },
  {
    nameColumn: "leaveType",
  },
  {
    nameColumn: "user",
  },
  // {
  //   nameColumn: "skill",
  // },
  {
    nameColumn: "role",
  },
  {
    nameColumn: "employee",
  },
  {
    nameColumn: "department",
  },
  {
    nameColumn: "designation",
  },
  {
    nameColumn: "branch",
  },
  {
    nameColumn: "offerTerm",
  },
  {
    nameColumn: "earningComponent",
  },

  {
    nameColumn: "deductionsComponent",
  },
  {
    nameColumn: "task",
  },
  {
    nameColumn: "product",
  },
  {
    nameColumn: "username",
  },
  {
    nameColumn: "discountType",
  },
  {
    nameColumn: "brand",
  },
  {
    nameColumn: "uom",
  },
  {
    nameColumn: "barcodeType",
  },
  {
    nameColumn: "materialRequestType",
  },
  {
    nameColumn: "uom",
  },
  {
    nameColumn: "attribute",
  },
  {
    nameColumn: "defaultWarehouse",
  },
  {
    nameColumn: "country",
  },
  {
    nameColumn: "checkIn",
  },
  {
    nameColumn: "defaultPriceList",
  },
  {
    nameColumn: "activityType",
  },
  {
    nameColumn: "project",
  },
  {
    nameColumn: "contractType",
  },
  {
    nameColumn: "attachment",
  },
  {
    nameColumn: "category",
  },
  {
    nameColumn: "fieldinBankTransaction",
  },
];
